








import Vue from 'vue';

export default Vue.extend({
  props: {
    title: { type: String, default: undefined },
    message: { type: String, default: undefined },
    hasCloseButton: { type: Boolean, default: true },
  },
  methods: {
    close() {
      this.$emit('input');
    },
  },
});
